<template>
  <div class="loader" >
    <svg class="circle-progress">
        <circle class="bg" cx="12" cy="12" r="9"></circle>
        <circle class="progress" cx="12" cy="12" r="9"></circle>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'Loader',
};
</script>
